/**TYPES FOR API ACTIONS */
export const PUSH_USER_DATA = "PUSH_USER_DATA";
export const PUSH_USER_DATA_ERROR = "PUSH_USER_DATA_ERROR";
export const RESET_USER_DATA = "RESET_USER_DATA";

/**TYPES FOR CMS AUTH ACTIONS */
export const PUSH_TOKEN = "PUSH_TOKEN";
export const PUSH_TOKEN_ERROR = "PUSH_TOKEN_ERROR";
export const RESET_TOKEN = "RESET_TOKEN";

export const GET_ALL_PROVINCIAS = "GET_ALL_PROVINCIAS";
export const GET_ALL_SERVICIOS = "GET_ALL_SERVICIOS";
export const GET_ALL_SUCURSALES = "GET_ALL_SUCURSALES";
export const GET_ALL_TIPOS_CONVENIOS = "GET_ALL_TIPOS_CONVENIOS";
export const GET_ALL_CONVENIOS = "GET_ALL_CONVENIOS";
export const GET_BIENES_SEARCH = "GET_BIENES_SEARCH";
export const GET_BIENES_SEARCH_ERROR = "GET_BIENES_SEARCH_ERROR";
export const BIENES_CLEAR = "BIENES_CLEAR";

export const GET_ALL_CONVENIOS_TILES = "GET_ALL_CONVENIOS_TILES";
export const GET_ALL_CONVENIOS_TILES_ERROR = "GET_ALL_CONVENIOS_TILES_ERROR";

export const GET_TIPOS_BIEN = "GET_TIPO_SERVICIO";
export const GET_TIPOS_BIEN_ERROR = "GET_TIPO_SERVICIO_ERROR";

export const GET_ALL_CANTONES = "GET_ALL_CANTONES";
export const GET_ALL_CANTONES_ERROR = "GET_ALL_CANTONES_ERROR";
export const GET_ALL_DISTRITOS = "GET_ALL_DISTRITOS";
export const GET_ALL_DISTRITOS_ERROR = "GET_ALL_DISTRITOS_ERROR";

//#region TYPES FOR CMS ACTIONS
export const GET_NAVIGATION_ROUTES_FROM_CMS = "GET_NAVIGATION_ROUTES_FROM_CMS";
export const GET_NAVIGATION_ROUTES_FROM_CMS_ERROR =
  "GET_NAVIGATION_ROUTES_FROM_CMS_ERROR";
export const GET_CMS_SITE_SECTIONS_TITLE = "GET_CMS_SITE_SECTIONS_TITLE";
export const GET_CMS_SITE_SECTIONS_TITLE_ERROR =
  "GET_CMS_SITE_SECTIONS_TITLE_ERROR";

export const GET_CMS_PRODUCTOS_AHORRO_CREDITO =
  "GET_CMS_PRODUCTOS_AHORRO_CREDITO";
export const GET_CMS_PRODUCTOS_AHORRO_CREDITO_ERROR =
  "GET_CMS_PRODUCTOS_AHORRO_CREDITO_ERROR";

export const GET_CMS_BARRA_INTERMEDIA = "GET_CMS_BARRA_INTERMEDIA";
export const GET_CMS_BARRA_INTERMEDIA_ERROR = "GET_CMS_BARRA_INTERMEDIA_ERROR";

export const GET_CMS_MAIN_MENU_SECTIONS = "GET_CMS_MAIN_MENU_SECTIONS";
export const GET_CMS_MAIN_MENU_SECTIONS_ERROR =
  "GET_CMS_MAIN_MENU_SECTIONS_ERROR";

//#endregion TYPES FOR CMS ACTIONS

//#region TYPES FOR INTERCONEXION ACTIONS
export const VALIDATE_DELEGATES = "VALIDATE_DELEGATES";
export const RESET_DELEGATES = "RESET_DELEGATES";
//#endregion TYPES FOR INTERCONEXION ACTIONS

//#region TYPES FOR TIPO DE CAMBIO ACTIONS
export const GET_TIPO_CAMBIO = "GET_TIPO_CAMBIO";
export const GET_TIPO_CAMBIO_ERROR = "GET_TIPO_CAMBIO_ERROR";
//#endregion TYPES FOR INTERCONEXION ACTIONS